import { SI_ROOT_ROUTE } from "app/pages/sales-intelligence/constants/routes";
import {
    PLAYBOOK_CREATE_ROUTE,
    PLAYBOOK_CREATE_URL,
    PLAYBOOK_EDIT_ROUTE,
    PLAYBOOK_EDIT_URL,
    PLAYBOOKS_ROUTE,
    PLAYBOOKS_URL,
} from "app/pages/sales-intelligence/constants/sl_routes";
import PlaybookWizardContainer from "app/pages/sales-intelligence/pages/playbooks/containers/PlaybookWizardSignalsHandlerContainer";
import { PlaybooksPageContainer } from "app/pages/sales-intelligence/pages/playbooks/containers/PlaybooksPageContainer/PlaybooksPageContainer";
import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";
import type { SecondaryBarType } from "app/reducers/_reducers/SecondaryBarReducer";
import { fallback } from "app/routes/handlers/redirectFunctions/fallback";
import { redirectPipe } from "app/routes/handlers/redirectFunctions/redirectPipe";
import type { RouterStateConfig } from "single-spa/react-app/router/IRouterState";

export const playbooksConfig: RouterStateConfig = {
    [PLAYBOOKS_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: PLAYBOOKS_URL,
        configId: "SalesWorkspace",
        stateId: PLAYBOOKS_ROUTE,
        component: PlaybooksPageContainer,
        pageTitle: "si.pages.playbooks.document_title",
        trackingId: {
            section: "SI_admin",
            subSection: "playbooks",
            subSubSection: "playbooks management",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
        isHidden: () => !salesSettingsHelper.isSalesPlaybooksEnabled,
    },
    [PLAYBOOK_CREATE_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: PLAYBOOK_CREATE_URL,
        configId: "SalesWorkspace",
        stateId: PLAYBOOK_CREATE_ROUTE,
        component: PlaybookWizardContainer,
        pageTitle: "si.playbooks.wizard.title.new",
        trackingId: {
            section: "SI_admin",
            subSection: "playbooks",
            subSubSection: "playbook create",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
        isHidden: () => !salesSettingsHelper.isSalesPlaybooksEnabled,
        params: {
            shared: { type: "bool", value: false },
        },
    },
    [PLAYBOOK_EDIT_ROUTE]: {
        parent: SI_ROOT_ROUTE,
        url: PLAYBOOK_EDIT_URL,
        configId: "SalesWorkspace",
        stateId: PLAYBOOK_EDIT_ROUTE,
        component: PlaybookWizardContainer,
        pageTitle: "si.playbooks.wizard.title.edit",
        trackingId: {
            section: "SI_admin",
            subSection: "playbooks",
            subSubSection: "playbook edit",
        },
        isSecondaryBarOpen: false,
        secondaryBarType: "None" as SecondaryBarType,
        params: {
            id: { type: "int" },
        },
        redirectTo: redirectPipe(
            fallback({
                salesIntelligence: "salesIntelligence-home",
            }),
        ),
        isHidden: () => !salesSettingsHelper.isSalesPlaybooksEnabled,
    },
};
